import {
  Files,
  HeartStraight,
  UserCircle,
  AddressBookTabs,
} from '@phosphor-icons/react';

import { AdditionalCategoryKeys } from 'theSource/app/routes';

export const ADDITIONAL_NAVIGATION_ICONS: Record<
  AdditionalCategoryKeys,
  JSX.Element
> = {
  profile: <UserCircle size={24} weight="duotone" />,
  benefits: <HeartStraight size={24} weight="duotone" />,
  company: <Files size={24} weight="duotone" />,
  account: <AddressBookTabs size={24} weight="duotone" />,
};
